import { render, staticRenderFns } from "./sharedBankCollateralDetails.vue?vue&type=template&id=45f67d44&"
import script from "./sharedBankCollateralDetails.vue?vue&type=script&lang=js&"
export * from "./sharedBankCollateralDetails.vue?vue&type=script&lang=js&"
import style0 from "./sharedBankCollateralDetails.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDataTable,VRow,VTextField})
